/* eslint-disable react/prefer-stateless-function */
import React from 'react';

class ContactWileyBlock extends React.Component {
  render() {
    return (
      <div>
        <div className="container contact-details-container">
          <div className="row">
            <div className="col-12">
              <p className="contact-wiley-title">CONTACT WILEY</p>
              <p className="contact-wiley-content">{this.props.contact.name}</p>
              <p className="contact-wiley-content">Phone: {this.props.contact.phone}</p>
              <p className="contact-wiley-content">
                Email: <a className="emailClass">{this.props.contact.email}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactWileyBlock;
